export const CONTENT_TYPE_BADGE = 'Badge';
export const CONTENT_TYPE_PIN = 'Pin';
export const CONTENT_TYPE_USER = 'User';

export const CONTENT_TYPES = [CONTENT_TYPE_BADGE, CONTENT_TYPE_PIN];
